import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { initI18n } from './i18n/init.js';
import { initSentryClient } from './observability/sentry-client.js';
import { App } from './App.js';
import { loadStoredPreferences } from './preferences/usePreferences.js';
import { syncReducedMotionAttribute } from './preferences/reducedMotion.js';
import './design/fonts.js';
import './design/global.css';

/* Stamp <html data-reduced-motion> before first render: CSS gates on the
   attribute, so waiting for the App effect would let one frame of suppressed
   animation through for toggle-on players. */
syncReducedMotionAttribute(loadStoredPreferences().reducedMotion);

initSentryClient({
  dsn: import.meta.env.VITE_SENTRY_DSN_CLIENT,
  /* Build-time-injected SHA, not an env var. See vite-env.d.ts + vite.config.ts. */
  release: __BUILD_SHA__,
});

async function bootstrap(): Promise<void> {
  const i18n = await initI18n('en');
  const root = document.getElementById('root');
  if (!root) throw new Error('No #root element');
  createRoot(root).render(
    <StrictMode>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </StrictMode>,
  );
}

void bootstrap();
